import React from 'react';
import {Field, ErrorMessage} from 'formik';
import {injectIntl} from 'react-intl';
import get from 'lodash/get';
import classNames from 'classnames';
import Error from '../../Error';
import messages from '../../../../res/translations/messages';

const NumericSelect = ({id, intl, name, options}) => (
    <>
        <Field name={name}>
            {({field, form}) => {
                const normalizedValue = field.value === '' || field.value === undefined? '': Number(field.value);
                const hasError = !!get(form.touched, name) && !!get(form.errors, name);
                return (
                    <select
                        {...field}
                        id={id}
                        className={classNames('form-control custom-select', {error: hasError})}
                        value={normalizedValue}
                        // eslint-disable-next-line react/jsx-no-bind
                        onChange={(event) => {
                            const {value} = event.target;
                            const parsedValue = value === '' ? '' : parseInt(value, 10);
                            form.setFieldValue(name, parsedValue);
                        }}
                    >
                        <option value="" disabled>{intl.formatMessage(messages.filters.select)}</option>
                        {options.map((option) => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                );
            }}
        </Field>
        <ErrorMessage name={name}>
            {(message) => <Error reason={message.key} reasonParams={message.params} />}
        </ErrorMessage>
    </>
);

export default injectIntl(NumericSelect);
